import { Button } from 'design-system';
import { FormattedMessage } from 'react-intl';
import styles from './CreateMembership.module.css';

const GroupButtons = ({ onBack, onNext, backKey, nextKey, style }) => {
  return (
    <div className={styles.groupButtons} style={style}>
      <Button type="default" onClick={onBack} htmlType="button" shape="round">
        <FormattedMessage id={backKey} />
      </Button>
      <Button type="primary" shape="round" onClick={onNext} htmlType="button">
        <FormattedMessage id={nextKey} />
      </Button>
    </div>
  );
};

export default GroupButtons;
